import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const PersonalInfo = props => {
  return (
    <Fragment>
      <h3>Personal Info</h3>
      <ul>
        <li>
          <b>Email:</b> {props.log.params.lis_person_contact_email_primary}
        </li>
        <li>
          <b>Given Name:</b> {props.log.params.lis_person_name_given}
        </li>
        <li>
          <b>Family Name:</b> {props.log.params.lis_person_name_family}
        </li>
        <li>
          <b>Full Name:</b> {props.log.params.lis_person_name_full}
        </li>
      </ul>
    </Fragment>
  )
}
export default PersonalInfo

PersonalInfo.propTypes = {
  log: PropTypes.object,
}
